import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  isUpliftAvailable: false,
  setIsUpliftAvailable: Function.prototype,
  isUpliftSelected: false,
  setIsUpliftSelected: Function.prototype,
  isUpliftTokenSet: false,
  setIsUpliftToken: Function.prototype,
  paymentToken: false,
  setPaymentToken: Function.prototype,
};

export const UpliftStateContext = createContext(defaultState);
export const useUpliftState = () => useContext(UpliftStateContext);

const UpliftStateProvider = props => {
  const [isAvailable, setIsAvailable] = useState(false);
  const [isUpliftSelected, setIsUpliftSelected] = useState(false);
  const [isUpliftTokenSet, setIsUpliftToken] = useState(false);
  const [paymentToken, setPaymentToken] = useState(null);

  return (
    <UpliftStateContext.Provider
      value={{
        isUpliftAvailable: isAvailable,
        setIsUpliftAvailable: setIsAvailable,
        isUpliftSelected: isUpliftSelected,
        setIsUpliftSelected: setIsUpliftSelected,
        isUpliftTokenSet: isUpliftTokenSet,
        setIsUpliftToken: setIsUpliftToken,
        paymentToken: paymentToken,
        setPaymentToken: setPaymentToken,
      }}
    >
      {props.children}
    </UpliftStateContext.Provider>
  );
};

UpliftStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UpliftStateProvider;
